import axiosInstance from '../auth/FetchInterceptor'
import { API_URL } from '../constants/environment'

export type GetUserInfoResponse = {
  company_id: string;
  contact_id: string;
  email: string;
  name: string;
  phone: string;
}

export type UserServiceType = {
  getUserInfo: () => Promise<GetUserInfoResponse>
}

const UserInfoService: UserServiceType = {
  getUserInfo: () =>
    axiosInstance.get<never, GetUserInfoResponse>(
      `${API_URL.CUSTOMER_AREA}/user-info`,
    ),
}

export default UserInfoService

